import type { Section } from "./hooks";

export const partitionSitemapSections = (sections: Section[], shape: number[]): Section[][] => {
  const result: Section[][] = [];
  let currentIndex = 0;

  for (const size of shape) {
    if (currentIndex >= sections.length) {
      // No more elements left, push empty array
      result.push([]);
    } else if (currentIndex + size <= sections.length) {
      result.push(sections.slice(currentIndex, currentIndex + size));
    } else {
      // Not enough elements, take what's left
      result.push(sections.slice(currentIndex));
    }

    currentIndex += size;
  }

  return result;
};
